import { AuthAuthPermissions } from '@robovision/rvai-auth'
import type { RvaiAbilityBuilder } from '../types'


export function defineResourcesAbility (
  builder: RvaiAbilityBuilder,
  permissions: AuthAuthPermissions[],
): void {
  const { can } = builder

  if (permissions.some(p => p === AuthAuthPermissions.SYSTEM_MANAGEMENT)) {
    can('crud', 'Resource')
  }

  if (
    permissions.some(p =>
      p === AuthAuthPermissions.INFERENCE ||
      p === AuthAuthPermissions.MODEL_CREATION)
  ) {
    can('read', 'Resource')
  }
}
